import * as React from "react";
import {cx} from "emotion";

import "./paper-type.scss";

import {
    isPickPack, is3rdPartyWorkflow
}                       from "@Common/logic/template-options/template-options-pickpack-data-logic";
import {cs}             from "@Common/react/chain-services";
import {Invoke}         from "@Common/react/invoke";
import {scopedState}    from "@Common/react/scoped-state";
import {Select}         from "@Common/ui-components/heavy/common/design2/select/select";
import {
    getDefaultPaperType, getPaperTypesFromMethod, sideMatches
}                       from "@Common/ui-components/heavy/item-options/modules/paper-type-logic";
import {keepOnly, omit} from "@Common/utils/objects";

import {Coating} from "./coating/coating";

export const PaperType = ({componentState, templateOptions, className, templateBack, templateBackId}) => cs(
    ["optionsState", (_, next) => next(scopedState(componentState, ['selections', 'options'] ))],
    ["method", (_, next) => next(componentState.value?.selections?.distributionType)],
    ["paperTypes", ({method}, next) => next(getPaperTypesFromMethod({method, templateOptions}))],
    ({optionsState, paperTypes}, next) => paperTypes.length > 0 && !optionsState.value?.find((o) => o?.dev_key === "paper_type") ? (
        Invoke({ fn: () => optionsState.change(
            (options) => getInitialOptionsState({options, paperTypes, templateOptions})
        )})
    ) : (
        next()
    ),
    ["paperType", ({optionsState}, next) => next(optionsState.value?.find((o) => o?.dev_key === "paper_type"))],
    ["finishingTypes", ({paperType, paperTypes}, next) => next(paperTypes.find((pt) => pt.id === paperType.id)?.subOptions)],
    ["finishing", ({optionsState, finishingTypes}, next) => next(
        getFinishingType({templateOptions, optionsState, finishingTypes})
    )],
    ({optionsState, paperTypes, paperType, finishing, finishingTypes}) => (
        !isPickPack(templateOptions) && !is3rdPartyWorkflow(templateOptions) && <div className={cx("paper-type-2e5", className)}>
            {paperType && <>
                <div className="header">
                    <div className="title" xd-qa-type="label" xd-qa-name="Paper Type">Paper Type:</div>
                </div>

                {paperTypes?.length === 1 ? (
                    <div className="value" xd-qa-type="text_field" xd-qa-name="Paper Type">
                        {paperType.name}
                    </div>
                ) : (
                    <div className="card">
                        <div className="select">
                            {Select({
                                list: paperTypes,
                                itemToLabel: (o) => o?.name,
                                itemToInfo: () => null,
                                onChange: (o) => optionsState.change((currentState) =>
                                    [
                                        ...currentState?.filter((o) => o?.dev_key !== "paper_type"),
                                        omit(paperTypes.find((pt) => pt.id === o.id), ["productPrice", "subOptions", "distributionFilter"])
                                    ]
                                ),
                                isSelected: (o) => o.id === paperType?.id,
                                forcedExpandLeft: true,
                                xdQaName: "Paper Type",
                            })}
                        </div>
                    </div>
                )}
                {finishingTypes?.length === 1 ? (<>
                    <div className="header">
                        <div className="title" xd-qa-type="label" xd-qa-name="Coating Type">Coating Type:</div>
                    </div>
                    <div className="value" xd-qa-type="text_field" xd-qa-name="Paper Type">
                        {`${finishingTypes[0].subGroup} ${finishingTypes[0].name}`}
                    </div>
                </>) : (
                    <div className="card">
                        {Coating({
                            finishingTypes,
                            selected: finishing,
                            onSelect: (finishing) => optionsState.change((currentState) =>
                                [
                                    ...currentState?.filter((o) => o?.group !== "Finishing"),
                                    ...finishing.type != "none" ? [keepOnly(finishing, ["id", "dev_key", "group"])] : []
                                ]
                            ),
                            templateBack,
                            templateBackId,
                        })}
                    </div>
                )}
            </>}
        </div>
    ),
);

const getInitialOptionsState = ({options, paperTypes, templateOptions}) => {
    const defaultOptionsState = [
        omit(getDefaultPaperType({paperTypes}), ["productPrice", "subOptions", "distributionFilter"]),
        omit(getFinishingTypeDefault({
            templateOptions, 
            finishingTypes: getDefaultPaperType({paperTypes})?.subOptions
        }), 
            ["productPrice", "subOptions", "distributionFilter"])
    ]

    if(!options) {
        return defaultOptionsState
    }

    return [...options].concat(defaultOptionsState)
}

const getFinishingType = ({templateOptions, optionsState, finishingTypes}) => {
    if(!finishingTypes) {
        return null
    }

    if(finishingTypes[0]?.required) {
        return  finishingTypes[0]
    }

    const groupFinishing = optionsState.value?.find((option) => option?.group === "Finishing")
    if(groupFinishing) {
        const finishingTypesMatch = finishingTypes.find((type) => (
            type.id === groupFinishing.id &&
            type.dev_key === groupFinishing.dev_key
        ))
        if(finishingTypesMatch) {
            return finishingTypesMatch
        }

    }

    return null
}

const getFinishingTypeDefault  = ({templateOptions, finishingTypes}) => {
    if(finishingTypes[0]?.required) {
        return  finishingTypes[0]
    }
   
    if(!templateOptions.defaultCoatingType) {
        return null
    } 

    if(!templateOptions.defaultCoatingSide) {
        return null
    } 
        
    if(templateOptions.defaultCoatingType === "none") {
        return null
    }

    const congruentSides = finishingTypes.find((type) => (
        type.dev_key === templateOptions.defaultCoatingType && 
        sideMatches(templateOptions.defaultCoatingSide, type)
    ))
    if(congruentSides) {
        return congruentSides
    }
    
    return null
}
